import { EventApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useUpdateStatus() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventApi.patchStatus, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).detail(String(variables.id)),
      });
    },
  });
}

export default useUpdateStatus;
